var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useAccountFeaturesQuery } from "@syf-api-library/account-features";
import { useAccountSummaryV2Query as useAccountSummaryQuery } from "@syf-api-library/account-summary";
import { useCreditAccountsQuery } from "@syf-api-library/credit-accounts";
import { useQueryClient, } from "@tanstack/react-query";
import { useAccountCardContext } from "../context/AccountCardContext";
import getApiConfig from "../helpers/getApiConfig";
import { useConfig } from "../hooks/useConfig";
export var useAccountSummary = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAccountSummaryQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
export var useAccountFeatures = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var featureFlags = useAccountCardContext().state.featureFlags;
    var shouldDisableAccountFeaturesApi = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.shouldDisableAccountFeaturesApi;
    var apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId) && !shouldDisableAccountFeaturesApi);
    return useAccountFeaturesQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
export var useCreditAccounts = function (shouldCallCreditAccountsQuery) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, shouldCallCreditAccountsQuery);
    return useCreditAccountsQuery(__assign({}, apiConfig));
};
//# sourceMappingURL=syfApiQueries.js.map